import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3CrisisPageState() {
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const crisisPage = useSelector((state: RootState) => state.treatmentPlanV3.crisisPage);
  const crisisPlans = crisisPage?.crisis_plans ?? [];
  const noCrisisPlanNeeded = crisisPage?.no_crisis_plan_needed ?? false;
  const crisisPageReady = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.crisisPage != null &&
      state.treatmentPlanV3.crisisPageTreatmentPlanId === treatmentPlanId,
  );
  const hasCrisisLoadError = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.crisisPageError != null && state.treatmentPlanV3.crisisPage == null,
  );
  const assessmentPage = useSelector((state: RootState) => state.treatmentPlanV3.assessmentPage);
  const behaviors = assessmentPage?.behaviors ?? [];
  const noMaladaptiveBehavior = assessmentPage?.no_maladaptive_behavior ?? false;
  const assessmentPageReady = assessmentPage != null;
  const hasAssessmentLoadError = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.assessmentPageError != null &&
      state.treatmentPlanV3.assessmentPage == null,
  );
  const crisisPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.crisisPageLoading,
  );
  const isLoading =
    crisisPageLoading ||
    (!crisisPageReady && !hasCrisisLoadError) ||
    (!assessmentPageReady && !hasAssessmentLoadError);
  const isSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createCrisisPlanLoading ||
      state.treatmentPlanV3.updateCrisisPlanLoading ||
      state.treatmentPlanV3.deleteCrisisPlanLoading ||
      state.treatmentPlanV3.deleteAllCrisisPlansLoading ||
      state.treatmentPlanV3.setNoCrisisPlanNeededLoading,
  );
  const isBulkSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.deleteAllCrisisPlansLoading ||
      state.treatmentPlanV3.setNoCrisisPlanNeededLoading,
  );

  return {
    crisisPlans,
    behaviors,
    noCrisisPlanNeeded,
    noMaladaptiveBehavior,
    crisisPageReady,
    hasCrisisLoadError,
    assessmentPageReady,
    hasAssessmentLoadError,
    isLoading,
    isSaving,
    isBulkSaving,
  };
}
